import { render, staticRenderFns } from "./GroupStudentSelector.vue?vue&type=template&id=f0a6fe46"
import script from "./GroupStudentSelector.vue?vue&type=script&lang=js"
export * from "./GroupStudentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports